import { useQuery } from "@tanstack/react-query";
import jobsList from "Api/jobs/list";
import { JobsRequestList } from "Services/Job/job";

export function useJobs(params: JobsRequestList) {
  const query = () => jobsList(params);

  return useQuery(["jobsList", ...Object.values(params)], query);
}
